import { useEffect, useState, useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { IUser, pageInfoState, userState } from '../../atoms';
import { ITabObject } from 'customTypes';
import Tab from '../../components/Tab';
import { useApprovalAlertAt } from '../../hooks/useApprovalAlertEntry';
import AttendanceForm from '../../components/AttendanceForm';
import DraftForm from '../../components/DraftForm';

const Cwork4 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const userInfo = useRecoilValue<IUser>(userState);
  const [searchParams] = useSearchParams();
  const tabCd = searchParams.get('tabCd');
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabCd || tabInfo.defaultMrCd);
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { userMenuList } = userInfo;
  const approvalAlertAt = useApprovalAlertAt();

  // URL의 tabCd 파라미터 변경 감지하여 탭 업데이트
  useEffect(() => {
    if (tabCd && tabCd !== currentTabMrCd) {
      setCurrentTabMrCd(tabCd);
    }
  }, [tabCd]);

  // 알림으로 들어오면 주소의 tabCd가 그대로여도(다른 탭을 눌러 둔 경우) 결재 탭으로 옮긴다
  useEffect(() => {
    if (approvalAlertAt && tabCd) setCurrentTabMrCd(tabCd);
  }, [approvalAlertAt]);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = useCallback(() => {
    const activeTab = userMenuList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);

    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <DraftForm key='request' approvalType='request' />; // 기안 신청
        case '002':
          return <DraftForm key='approval' approvalType='approval' />; // 기안 결재
      }
    }
    return null;
  }, [currentTabMrCd]);

  return (
    <div className='contents'>
      <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default Cwork4;
